import Vue from 'vue'

import { RootState, ITagState, Module } from '../types'
import { Tag, TagDictionary, SubscribtionPayload } from '@/types/tag'

import { getTags, getTagsValue } from '@/api/tags'

import socket from '@/socket.io'

let subscribedTag = false
export const tag: Module<ITagState, RootState> = {
  namespaced: true,
  state() {
    return {
      items: {},
      grouped: [],
      initialized: false,
      poolEnabled: false,
      subscribed: false,
    }
  },

  getters: {
    // Get tag in group
    byGroup: (state) => (group: string) => {
      // eslint-disable-next-line
      return state.items.filter((item: any) => item.group_uid === group)
    },

    // Get tag items
    items: (state) => state.items,
    itemsArray: (state) => {
      return Object.keys(state.items).map((uid) => state.items[uid])
    },

    grouped: (state) => state.grouped,
  },

  mutations: {
    // eslint-disable-next-line
    SET_ITEMS(state, payload: Tag[]) {
      state.items = payload
      state.initialized = true
    },
    UPDATE_TAGS_VALUE(state, payload: SubscribtionPayload) {
      if (Object.keys(state.items).length === 0) return
      payload.fields.forEach((field, index) => {
        try {
          // This is trick to trigger mapState update
          Vue.set(state.items[field], 'timestamp', payload.data[index][0])
          Vue.set(state.items[field], 'raw', payload.data[index][1])
          Vue.set(state.items[field], 'value', payload.data[index][2])
          Vue.set(state.items[field], 'good', payload.data[index][3])
        } catch (e) {
          // eslint-disable-next-line
          // console.log(field)
        }
      })
    },
    SET_POOL_ENABLED(state) {
      state.poolEnabled = true
    },
    // eslint-disable-next-line
    SET_POOL_DISABLE(state) {
      state.poolEnabled = false
    },
    // eslint-disable-next-line
    SET_GROUPED(state, payload: any) {
      state.grouped = payload
    },
  },

  actions: {
    async get({ commit }) {
      const data = await getTags()
      const tags: TagDictionary = {}
      for (const i in data) {
        const tag = data[i]
        tags[tag.uid] = tag
      }
      commit('SET_ITEMS', tags)
    },

    subscribe({ state }) {
      socket.emit('subscribe-tag')
      if (subscribedTag) return
      subscribedTag = true
      socket.on('publish_tags', (payload: SubscribtionPayload) => {
        // commit('UPDATE_TAGS_VALUE', payload)

        if (Object.keys(state.items).length === 0) return
        if (payload.fields == null) {
          return
        }
        payload.fields.forEach((field, index) => {
          try {
            // This is trick to trigger mapState update
            Vue.set(state.items[field], 'timestamp', payload.data[index][0])
            Vue.set(state.items[field], 'raw', payload.data[index][1])
            Vue.set(state.items[field], 'value', payload.data[index][2])
            Vue.set(state.items[field], 'good', payload.data[index][3])
          } catch (e) {
            // eslint-disable-next-line
            // console.log(field)
          }
        })
      })
    },

    // async fetchGrouped({ commit }) {
    //   const { data } = await getTagsGrouped()
    //   commit('SET_GROUPED', data)
    // },

    async updateTagsValue({ commit }) {
      const tags = await getTagsValue()
      commit('UPDATE_TAGS_VALUE', tags)
    },
    async enableTagsPool({ state, commit }) {
      if (state.poolEnabled) {
        return
      }
      commit('SET_POOL_ENABLED')
    },
    async disableTagsPool({ commit }) {
      commit('SET_POOL_DISABLE')
    },
  },
}
